import { isClient } from "./isClient";

export const isBrowser = isClient;
